import React, { useState, useEffect, Fragment } from "react";
import { Col, Container, Row, Table, Image } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import PropTypes from "prop-types";
import {
  get_subscription_details,
  admin_payout_vendor,
} from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import Dialog from "@material-ui/core/Dialog";

import DialogContent from "@material-ui/core/DialogContent";
import { useHistory } from "react-router";
import {
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { CheckCircle, Report } from '@material-ui/icons'
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { errorAlert, successAlert } from "../../../../function/alert";
import Alert from "react-s-alert";
import axios from "axios";
import { NEFT, serverApi } from "../../../../config/Keys";
import {
  CLEAR_LOADER,
  SET_LOADER,
  SINGLE_VENDOR_SETTLEMENT,
} from "../../../../store/types";
import { AdminTwilioCallingModal } from "../superAdminVendor/superAdminVendorTable/firstPageTable/AllVendorTableBody";
import SuperAdminChatWindowPopup from "../superAdminPendingVendors/SuperAdminChatWindowPopup";
import { SuperAdminSMS } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import { SuperAdminNotification } from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import InfoToolTip from "../../../reusableComponents/InfoTooltipComponent";
import isEmpty from "../../../../store/validation/is-Empty";
import OrderViewModal from "../../../reusableComponents/OrderViewModal";
import { amApi } from "../../../../api/apiHelper";
import { ORDER_STATUS, ORDER_TYPE_NAME } from "../../../../enums/OrderEnums";
import ViewExpReqDetails from "../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpReqDetails";
import SelectFilter from "../../../reusableComponents/selectFilter";

const CancelledOrders = (props) => {
  const [state, setState] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [bankData, setBankData] = useState([]);
  const [showTip, setShowTip] = useState(false);
  const [tipBankData, setTipBankData] = useState({});
  const [showBlock, setShowBlock] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [reason, setReason] = useState("");
  const [blockData, setBlockData] = useState({ type: "", id: "", bType: "" });
  const [dateQuery, setDateQuery] = useState({});
  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };
  const [disabled, setDisabled] = useState(
    props.location && props.location.state && props.location.state.access
      ? props.location.state.access
      : false
  );
  const [orderDetail, setOrderDetail] = useState({});

  const [selectedIDs, setSelectedIDs] = useState([]);

  const blockReasons = ["Blocked for Payment", "Skip Account"];
  const unblockReasons = ["Free for Payment"];

  const onSelect = (data) => {
    if (selectedIDs.some((ele) => ele === data)) {
      let newdata = selectedIDs.filter((ele) => ele !== data);
      setSelectedIDs(newdata);
      // let t = data.orderPayAmount + data.orderTipAmount + data.eventPayAmount + data.scanAndPayPayAmount;
      // setTotalAmount((parseFloat(totalAmount) - t).toFixed(2));
    } else {
      let newdata = [...selectedIDs, data];
      setSelectedIDs(newdata);
      // let t = data.orderPayAmount + data.orderTipAmount + data.eventPayAmount + data.scanAndPayPayAmount;
      // setTotalAmount((parseFloat(totalAmount) + t).toFixed(2));
    }
  };

  const handleShowClear = (data) => {
    if (data) {
      setSelectedIDs([data?._id]);
      setShowClear(true);
    } else if (selectedIDs.length) {
      setShowClear(true);
    } else {
      errorAlert("Select atleast on Request");
    }
  };

  const handleClear = async (data) => {
    let payload = {
      orderId: selectedIDs[0],
      reason: data.reason,
      number: data.number,
    };
    let manual = await amApi.post("/dunzoStatus", payload);
    if (manual.status === 201) {
      let orders = orderData.filter(
        (ele) => !selectedIDs.includes(ele._id.toString())
      );
      setOrderData(orders);
      successAlert("Manual Settled Successfully");
      setSelectedIDs([]);
      setShowClear(false);
    } else {
      errorAlert("Error while settling");
    }
  };

  const handleShowRefund = (data) => {
    if (data) {
      setSelectedIDs([data?._id]);
      setShowRefund(true);
    } else if (selectedIDs.length) {
      setShowRefund(true);
    } else {
      errorAlert("Select atleast on Request");
    }
  };

  const handleRefund = async (data) => {
    let payload = {
      orderId: selectedIDs[0],
      reason: data.reason,
      amount: data.amount,
    };
    let manual = await amApi.post("/admin/cancelledOrders", payload);
    if (manual.status === 201) {
      let orders = orderData.filter(
        (ele) => !selectedIDs.includes(ele._id.toString())
      );
      successAlert("Refund processed successfully");
      setSelectedIDs([]);
      setShowRefund(false);
    } else {
      errorAlert("Error while processing, try again later");
    }
  };


  const handleView = (data) => {
    setShowOrderDetail(true);
    setOrderDetail(data);
  };

  const showView = () => {
    setShowOrderDetail(false);
    setOrderDetail({});
  };

  const onSuccessPayout = (type) => {
    if (type === 0) {
      onClickPayOut("tip");
    } else {
      dispatch({ type: CLEAR_LOADER });
      history.push("/superadminopenitemsettlement");
    }
  };

  const onErrorPayout = (err) => {
    Alert.error(`<h4>${err ? err : "Something went wrong"} </h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onClickPayOut = (type) => {
    let amount =
      type === "total"
        ? parseFloat(props?.data?.orderPayAmount.toFixed(2))
        : type === "tip"
          ? parseFloat(props?.data?.orderTipAmount.toFixed(2))
          : type === "event"
            ? parseFloat(props?.data?.eventPayAmount?.toFixed(2))
            : type === "scan"
              ? parseFloat(props?.data?.scanAndPayPayAmount?.toFixed(2))
              : 0;
    if (bankData.fundId) {
      let formData = {};
      formData = {
        vendor_id: props.data.vendor_id._id,
        payout_type: type === "tip" ? 1 : state === 0 ? 0 : state === 1 ? 2 : 3,
        currency: "INR",
        settlement_account_details: {
          bankName: bankData.bankName,
          email: bankData.email,
          account_type: bankData.account_type,
          account_number: bankData.account_number,
          account_ifsc: bankData.account_ifsc,
          account_branch: bankData.account_branch,
          docs: bankData.docs,
          fundId: bankData.fundId,
          accountId: bankData.accountId,
        },
        settlement_amount: amount,
        total_amount: amount,
        payoutStartDate: new Date(props.data.startDate).getTime(),
        payoutEndDate: new Date(props.data.endDate).getTime(),
        totalEarnedComission:
          type === "tip"
            ? 0
            : state === 0
              ? props.data.orderComission
              : state === 1
                ? props.data.eventComission
                : 0,
      };

      if (state === 0) {
        formData.order_id = [];
        for (let i = 0; i < props.data.orders.length; i++) {
          if (
            !props?.data?.orders[i].blockSettlement &&
            !props?.data?.orders[i].settleOrderAmount
          ) {
            formData.order_id.push(props.data.orders[i]._id);
          }
        }
      } else if (state === 1) {
        formData.event_request_id = [];
        for (let i = 0; i < props.data.event_requests?.length; i++) {
          if (
            !props?.data?.event_requests[i].blockSettlement &&
            !props?.data?.orders[i].settleTipAmount
          ) {
            formData.event_request_id.push(props.data.event_requests[i]._id);
          }
        }
      } else if (state === 2) {
        formData.scan_and_pay_transactional_id = [];
        for (let i = 0; i < props.data.scan_and_pay?.length; i++) {
          if (!props?.data?.scan_and_pay[i].blockSettlement) {
            formData.scan_and_pay_transactional_id.push(
              props.data.scan_and_pay[i]._id
            );
          }
        }
      }
      const token = props.auth.user.accessToken;
      props.admin_payout_vendor(
        token,
        formData,
        onSuccessPayout,
        onErrorPayout
      );
    } else {
      onErrorPayout("Account Fund ID is missing/inappropriate");
    }
    // onErrorPayout('Settlement amount must be greater than "0"');
  };

  const showBlockPayment = (type, id, bType) => () => {
    setShowBlock(!showBlock);
    if (id) setSelectedIDs([id]);
    setBlockData({ type: type, id: id, bType: bType });
  };

  const submitPercentage = async (data) => {
    let payload = {
      orderId: selectedIDs[0],
      percentage: data.percentage
    };
    let manual = await amApi.post("/dunzoStatus", payload);
    if (manual.status === 201) {
      let orders = orderData.filter(
        (ele) => !selectedIDs.includes(ele._id.toString())
      );
      setOrderData(orders);
      successAlert("Submitted Successfully");
      setSelectedIDs([]);
      setShowBlock(false);
    } else {
      errorAlert("Error while settling");
    }
  };

  const [type, setType] = useState(0);
  const [showOrderDetail, setShowOrderDetail] = useState(false);

  const onTypeChange = (type) => {
    setType(type);
  };


  const [orderData, setOrderData] = useState([]);


  const getOrders = async () => {
    let query = { startDate: dateQuery.startDate, endDate: dateQuery.endDate };
    let orders = await amApi.get(`/admin/cancelledOrders`, { params: query });
    setOrderData(orders.data.orders);
  }

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      getOrders();
    }
  }, [dateQuery])

  return (
    <React.Fragment>
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation
              />
              <Container fluid>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div>
                      <div className="super_admin_add_vendor mb-1">
                        <p className="main_header_text">Cancelled Delivery Orders</p>
                      </div>
                    </div>
                  </div>
                  <div className="text-right" align="right">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <hr />
                <div>
                  <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                    <Table>
                      <thead>
                        <TableHead
                          display={
                            state === 0 ? (
                              <tr>
                                <th style={{ width: "6%" }}></th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Restaurant Name
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Order Type/ <br />
                                  Order ID
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Order Status
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Subtotal <br /> Of Items
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Discount
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Net Order <br /> Value
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Taxes
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Surcharges
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Tip
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Amount <br />
                                  Paid
                                </th>
                              </tr>
                            ) : null
                          }
                        />
                      </thead>
                      {state === 0 &&
                        orderData?.map((order, index) => (
                          <TableBody
                            orderData={order}
                            comissionCode={props?.data?.comissionCode}
                            key={index}
                            showBlockPayment={showBlockPayment}
                            loader={props.auth.loader}
                            handleView={handleView}
                            onSelect={onSelect}
                            selected={selectedIDs}
                            handleShowClear={handleShowClear}
                            handleShowRefund={handleShowRefund}
                          />
                        ))}
                    </Table>
                  </div>
                </div>
              </Container>
            </div>
          </div>
        </div>
        {showOrderDetail && (
          <OrderViewModal orderDetails={orderDetail} handleClose={showView} />
        )}
      </React.Fragment>
      {showBlock && (
        <PaymentBlock
          open={showBlock}
          showBlockPayment={showBlockPayment}
          blockReasons={blockReasons}
          setReason={setReason}
          reason={reason}
          unblockReasons={unblockReasons}
          submitPercentage={submitPercentage}
          blockData={blockData}
        />
      )}
      {showClear && (
        <ResetClear
          handleClose={() => setShowClear(false)}
          handleClear={handleClear}
        />
      )}
      {showRefund && (
        <RefundUser
          handleClose={() => setShowRefund(false)}
          handleRefund={handleRefund}
        />
      )}
    </React.Fragment>
  );
};

CancelledOrders.propTypes = {
  auth: PropTypes.object.isRequired,
  get_subscription_details: PropTypes.func.isRequired,
  admin_payout_vendor: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  data: state.superadminManageTransactions.single_vendor_settllement,
});

export default connect(mapStateToProps, {
  get_subscription_details,
  admin_payout_vendor,
})(CancelledOrders);

const TableHead = (props) => {
  return (
    <>
      {props?.display}
    </>
  );
};

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [data, setData] = useState({});

  const calcTaxes = (data) => {
    let tax = 0;
    if (!isEmpty(data)) {
      tax = Object.values(data).reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );
    }
    return tax.toFixed(2);
  };

  const orderComission = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value =
      ((order?.base_amount -
        (order?.offerSettlement === "ADMIN"
          ? 0
          : order?.discount?.amount || 0)) *
        comission) /
      100;
    let gst = (value * 18) / 100;
    return value + gst;
  };

  const orderComssionDetails = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (
      ((order?.base_amount -
        (order?.offerSettlement === "ADMIN"
          ? 0
          : order?.discount?.amount || 0)) *
        comission) /
      100
    ).toFixed(2);
    let gst = ((value * 18) / 100).toFixed(2);
    return { fee: value, gst: gst };
  };

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges =
      (data?.outgoingCharges?.fee || 0) + (data?.outgoingCharges?.tax || 0);
    let donation =
      data.donation && data.donation.amount ? data.donation.amount : 0;
    let payAmount = data.settleAmount;
    let comission = orderComission(data, props?.comissionCode);
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission;
      return orderPayAmount;
    } else {
      return orderPayAmount;
    }
  };

  useEffect(() => {
    let gst = calcTaxes(props.orderData.gstAmount);
    let sur = calcTaxes(props.orderData.surCharges);
    let comission = orderComission(
      props.orderData,
      props?.comissionCode
    ).toFixed(2);
    let settle = amountToSettle(props.orderData).toFixed(2);
    let comissionDetails = orderComssionDetails(
      props.orderData,
      props?.comissionCode
    );
    setData({ gst, sur, comission, settle, comissionDetails });
  }, [props]);

  const handleView = () => {
    props.handleView(props.orderData);
  };


  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className={` cursor enGrayBorderBox sd_body_tr`}
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${(props?.orderData?.blockSettlement) ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                <td style={{ width: "6%", textAlign: "center" }}>
                  {(props?.orderData?.blockSettlement) ? <Report style={{ color: "#EE3A23" }} />
                    : <CheckCircle style={{ color: "#06A200" }} />
                  }
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500 text-break pl-3">
                    {props?.orderData?.restaurant_id?.restaurant_name}
                    <br />
                    {props?.orderData?.restaurant_id?.city}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500 text-break pl-3">
                    {ORDER_TYPE_NAME[props.orderData.order_type]}
                    <br />
                    {props && props.orderData && props.orderData.order_id}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    {ORDER_STATUS[props?.orderData?.order_status]}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.base_amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.discount?.amount.toFixed(2) || 0}
                  </div>
                </td>

                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹{" "}
                    {(
                      (props?.orderData?.base_amount || 0) -
                      (props?.orderData?.discount?.amount || 0)
                    ).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 d-flex">₹{data?.gst}</div>
                    <InfoToolTip
                      title={"View the bifurcation of Taxes"}
                      data={props.orderData.gstAmount}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">₹ {data?.sur}</div>
                    <InfoToolTip
                      title={"View the bifurcation of Surcharges"}
                      data={props.orderData.surCharges}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {(props?.orderData?.tip?.amount || 0).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.total_amount?.toFixed(2) || 0}
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        {props.orderData.disputeId && (
                          <>
                            <div className="f12-500">
                              <div>Dispute Id</div>
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Amount
                              <div className="mt-3">₹ 0</div>
                            </div>
                            <div className="f12-500">
                              Disputed Items
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Status
                              <div className="mt-3">N/A</div>
                            </div>
                          </>
                        )}
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.orderData?.settleAfter)
                              .add(1, "day")
                              .format("MM-DD-YYYY")}
                            <br />
                            {/* {moment(props.orderData?.settleAfter).add(1, 'day').format("LT")} */}
                          </div>
                        </div>
                        <div className="f12-500">
                          No of Items
                          <div className="mt-3">
                            {props?.orderData?.order_items?.length}
                          </div>
                        </div>
                        {props?.orderData?.delivery_partner === 2 && <div className="f12-500">
                          Delivery Charges <br />
                          User/Merchant/Amealio
                          <div className="mt-3">
                            ₹{props?.orderData?.deliveryCharges?.user} / ₹{props?.orderData?.deliveryCharges?.merchant} / ₹{props?.orderData?.deliveryCharges?.amealio}
                          </div>
                        </div>}
                        <div className="f12-500">
                          Order Status
                          <div className="mt-3">
                            {ORDER_STATUS[props?.orderData?.order_status]}
                          </div>
                        </div>
                        <div className="f12-500">
                          Refund Percentage
                          <div className="mt-3">
                            {props?.orderData?.deliveryCharges?.cancelRefund || "N/A"}
                          </div>
                        </div>
                        <div className="f12-500">
                          Offer Type
                          <div className="mt-3">
                            {props?.orderData?.offerSettlement === "ADMIN"
                              ? "Amealio Offer"
                              : props?.orderData?.discount?.amount
                                ? "Merchant Offer"
                                : "N/A"}
                          </div>
                        </div>
                        <div className="f12-500">
                          Order Date
                          <div className="mt-3">
                            {" "}
                            {moment(props.orderData?.createdAt).format(
                              "MM-DD-YYYY"
                            )}
                            <br />
                            {moment(props.orderData?.createdAt).format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">
                            {props?.orderData?.blockReason || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Order Accepted Time</div>
                          <div className="mt-3">{moment(props?.orderData?.OrderAcceptTime).format("MM-DD-YYYY")}</div>
                          <div className="mt-3">{moment(props?.orderData?.OrderAcceptTime).format('LT')}</div>
                        </div>
                        <div className="f12-500">
                          <div>Order Cancelled Time</div>
                          <div className="mt-3">{moment(props?.orderData?.cancelledDate).format("MM-DD-YYYY")}</div>
                          <div className="mt-3">{moment(props?.orderData?.cancelledDate).format('LT')}</div>
                        </div>
                        <div className="f12-500">
                          <div>Cancelled Reason</div>
                          <div className="mt-3">{props?.orderData?.cancelReason}</div>
                        </div>
                        <div className="f12-500">
                          <div>Service Ticket Reason</div>
                          <div className="mt-3">{props?.orderData?.delivery_task?.serviceRequest?.reason}</div>
                        </div>
                        <div className="f12-500">
                          Donation
                          <div className="mt-3">
                            ₹ {props?.orderData?.donation?.amount || 0}
                          </div>
                        </div>
                        <div className="f12-500">
                          Amount Received
                          <div className="mt-3">
                            ₹ {(props?.orderData?.total_amount).toFixed(2)}
                          </div>
                        </div>
                        <div className="f12-500">
                          <div className="d-flex justify-content-around">
                            {props.orderData.disputeId && (
                              <div className="f10-400 m-2" align="center">
                                <img
                                  src={require("../../../../assets/images/iconButton/eye.png")}
                                  width="35px"
                                  alt="icon"
                                />
                                <br />
                                View <br /> Dispute
                              </div>
                            )}
                            {props.orderData?.blockSettlement &&
                              <>
                                <div
                                  className="f10-400 m-2"
                                  align="center"
                                  onClick={() =>
                                    props.handleShowClear(props.orderData)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={require("../../../../assets/images/iconButton/block.png")}
                                    width="35px"
                                    alt="icon"
                                  />
                                  <br />
                                  Raise <br /> Service Request
                                </div>
                                {(props.orderData?.ticketDetails?.resolved === false) && <div
                                  className="f10-400 m-2"
                                  align="center"
                                  onClick={() =>
                                    props.handleShowRefund(props.orderData)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={require("../../../../assets/images/iconButton/block.png")}
                                    width="35px"
                                    alt="icon"
                                  />
                                  <br />
                                  Refund User
                                </div>}
                                <div
                                  className="f10-400 m-2"
                                  align="center"
                                  onClick={props.showBlockPayment(
                                    props.orderData?.blockSettlement
                                      ? "UNBLOCK"
                                      : "BLOCK",
                                    props.orderData._id,
                                    "ORDER"
                                  )}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={require("../../../../assets/images/iconButton/Reset.svg")}
                                    width="35px"
                                    alt="icon"
                                  />
                                  <br />
                                  Clear to <br /> Settlement
                                </div></>}
                            <div
                              className="f10-400 m-2"
                              align="center"
                              onClick={handleView}
                            >
                              <img
                                src={require("../../../../assets/images/iconButton/eye.png")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              View <br /> Transaction
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};



const DialogForPayout = (props) => {
  return (
    <div>
      {props.tipBankData && props.disabled && (
        <div className="btn btn-danger" onClick={props.handleClickOpen}>
          Payout
        </div>
      )}
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" onClose={props.handleClose}>
          <div className="d-flex justify-content-between">
            <div>Payout Details</div>
            <div
              className="f18-500"
              onClick={props.handleClose}
              style={{ cursor: "pointer" }}
            >
              X
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <Fragment>
            {props?.selectedTab === 0 && (
              <>
                <div className="d-flex mb-2">
                  <div className="f16-700 mr-4">Total Payable Amount</div>
                  <div className="f16-700 mr-4">
                    ₹{" "}
                    {(
                      parseFloat(props.tipAmount) +
                      parseFloat(props.orderAmount)
                    ).toFixed(2)}
                  </div>
                </div>
                <div className="d-flex mb-2">
                  <div className="f14-500 mr-4">
                    Total Tip Amount To be Paid
                  </div>
                  <div className="f14-500 mr-4">₹ {props.tipAmount}</div>
                </div>
                <div className="d-flex mb-2">
                  <div className="f14-500 mr-4">
                    Total Ordering Amount To be Paid
                  </div>
                  <div className="f14-500 mr-4">₹ {props.orderAmount}</div>
                </div>
              </>
            )}
            {props?.selectedTab === 1 && (
              <>
                <div className="d-flex mb-2">
                  <div className="f16-700 mr-4">Total Payable Event Amount</div>
                  <div className="f16-700 mr-4">
                    ₹ {parseFloat(props.eventAmount).toFixed(2)}
                  </div>
                </div>
              </>
            )}
            {props?.selectedTab === 2 && (
              <>
                <div className="d-flex mb-2">
                  <div className="f16-700 mr-4">
                    Total Payable Scan & Pay Amount
                  </div>
                  <div className="f16-700 mr-4">
                    ₹ {parseFloat(props.scanAmount).toFixed(2)}
                  </div>
                </div>
              </>
            )}
            {props.showTip ? (
              <>
                <hr />
                <div className="f14-500 mb-2">Account Details for Tips</div>
                <div className="row mb-2">
                  <div className="col-4 f12-700 ">Name on Account </div>
                  <div className="col-4 f12-700 ">Type of Account</div>
                  <div className="col-4 f12-700 ">Account Number</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 f12-500 ">
                    {props && props.tipBankData && props.tipBankData.bankName}
                  </div>
                  <div className="col-4 f12-500 ">
                    {" "}
                    {props &&
                      props.tipBankData &&
                      props.tipBankData.account_type}{" "}
                    Account
                  </div>
                  <div className="col-4 ">
                    <div className="f12-500 ">
                      {" "}
                      {props &&
                        props.tipBankData &&
                        props.tipBankData.account_number}
                    </div>
                    <div className="f10-400 ">Account Number</div>
                  </div>
                  <div className="col-4 ">
                    <div className="f12-500 ">
                      {" "}
                      {props &&
                        props.tipBankData &&
                        props.tipBankData.account_ifsc}
                    </div>
                    <div className="f10-400 ">IFSC Code</div>
                  </div>
                </div>
              </>
            ) : (
              <> </>
            )}
            <hr />
          </Fragment>
          {/* <div className="d-flex mt-2 mb-2">
            <div className="f14-500 mr-4">Current Settlement Amount</div>
            <div>
              ₹{" "}
              {props.selectedTab === 0
                ? props.orderAmount
                : props.selectedTab === 1
                ? props.eventAmount
                : props.scanAmount}
            </div>
          </div> */}
          <div className="f14-500 mb-2">
            {`Account Details for ${props?.selectedTab === 0
              ? "Ordering"
              : props?.selectedTab === 1
                ? "Experiences"
                : "Scan & Pay"
              }`}
          </div>
          <div className="row mb-2">
            <div className="col-4 f12-700 ">Name on Account </div>
            <div className="col-4 f12-700 ">Type of Account</div>
            <div className="col-4 f12-700 ">Account Number</div>
          </div>
          <div className="row mb-2">
            <div className="col-4 f12-500 ">
              {props && props.bankData && props.bankData.bankName}
            </div>
            <div className="col-4 f12-500 ">
              {props && props.bankData && props.bankData.account_type} Account
            </div>
            <div className="col-4 ">
              <div className="f12-500 ">
                {props && props.bankData && props.bankData.account_number}
              </div>
              <div className="f10-400 ">Account Number</div>
            </div>
            <div className="col-4 ">
              <div className="f12-500 ">
                {props && props.bankData && props.bankData.account_ifsc}
              </div>
              <div className="f10-400 ">IFSC Code</div>
            </div>
          </div>
          {props.selectedTab === 0 && !props.showTip && (
            <div className="text-warning f12-700">
              No bank account has been added for Tips so that amount will be
              credited to the same account of orders
            </div>
          )}
          <hr />

          <div
            className="btn btn-outline-secondary mr-2"
            style={{ width: "150px" }}
            onClick={props.handleClose}
          >
            Cancel
          </div>
          {/* {props.selectedTab === 0 && props.showTip ? (
            <div
              className="btn btn-outline-danger mr-2"
              style={{ width: "150px" }}
              onClick={() => props.onClickPayOut("tip")}
            >
              Pay for Tips
            </div>
          ) : (
            <> </>
          )} */}
          <div
            className="btn btn-danger"
            style={{ width: "150px" }}
            onClick={() => {
              props.onClickPayOut(
                props.selectedTab === 0
                  ? "total"
                  : props.selectedTab === 1
                    ? "event"
                    : "scan"
              );
            }}
          >
            Pay for{" "}
            {props.selectedTab === 0
              ? "Order"
              : props.selectedTab === 1
                ? "Event"
                : "Scan And Pay"}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const PaymentBlock = (props) => {
  const [data, setData] = useState({
    percentage: ""
  });

  return (
    <Dialog open={true} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" onClose={props.handleClose}>
        <div className="d-flex justify-content-between">
          <div>Approve for Settlement</div>
          <div
            className="f18-500"
            onClick={props.showBlockPayment("", "", "")}
            style={{ cursor: "pointer" }}
          >
            X
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <FormControl variant="outlined" fullWidth>
            <TextField
              id="reference"
              variant="outlined"
              type="number"
              label="Percentage"
              name="percentage"
              className={`w-100`}
              onChange={(e) =>
                setData({ percentage: e.target.value })
              }
              value={data.percentage}
            />
          </FormControl>
        </div>
        <div
          className="btn btn-outline-secondary mr-2"
          style={{ width: "150px" }}
          onClick={props.showBlockPayment("", "", "")}
        >
          Cancel
        </div>
        <div
          className="btn btn-danger"
          style={{ width: "150px" }}
          onClick={() => props.submitPercentage(data)}
        >
          Submit
        </div>
      </DialogContent>
    </Dialog>
  );
};

const ResetClear = (props) => {
  const [clearData, setClearData] = useState({
    reason: "",
    number: "",
  });

  const onSubmit = () => {
    if (clearData?.reason && clearData.number) {
      props.handleClear(clearData);
    } else {
      errorAlert("Please enter all the details");
    }
  };

  return (
    <Dialog open={true} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" onClose={() => { }}>
        <div className="d-flex justify-content-between">
          <div>Raise Service Request</div>
          <div
            className="f18-500"
            onClick={props.handleClose}
            style={{ cursor: "pointer" }}
          >
            X
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "100%", marginBottom: "8px" }}>
          <FormControl variant="outlined" fullWidth>
            <TextField
              id="reference"
              variant="outlined"
              multiline
              rows={2}
              type="number"
              label="Reason"
              name="reason"
              className={`w-100`}
              onChange={(e) =>
                setClearData({ ...clearData, reason: e.target.value })
              }
              value={clearData.reason}
            />
          </FormControl>
        </div>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <TextField
            id="reference"
            variant="outlined"
            label="Number"
            name="number"
            className={`w-100`}
            onChange={(e) =>
              setClearData({ ...clearData, number: e.target.value })
            }
            value={clearData.number}
          />
        </div>
        <div
          className="btn btn-outline-secondary mr-2"
          style={{ width: "150px" }}
          onClick={props.handleClose}
        >
          Cancel
        </div>
        <div
          className="btn btn-danger"
          style={{ width: "150px" }}
          onClick={onSubmit}
        >
          Submit
        </div>
      </DialogContent>
    </Dialog>
  );
};


const RefundUser = (props) => {
  const [clearData, setClearData] = useState({
    reason: "",
    amount: "",
  });

  const onSubmit = () => {
    if (clearData?.reason && clearData.amount) {
      props.handleRefund(clearData);
    } else {
      errorAlert("Please enter all the details");
    }
  };

  return (
    <Dialog open={true} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" onClose={() => { }}>
        <div className="d-flex justify-content-between">
          <div>Refund User</div>
          <div
            className="f18-500"
            onClick={props.handleClose}
            style={{ cursor: "pointer" }}
          >
            X
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "100%", marginBottom: "8px" }}>
          <FormControl variant="outlined" fullWidth>
            <TextField
              id="reference"
              variant="outlined"
              multiline
              rows={2}
              type="text"
              label="Reason"
              name="reason"
              className={`w-100`}
              onChange={(e) =>
                setClearData({ ...clearData, reason: e.target.value })
              }
              value={clearData.reason}
            />
          </FormControl>
        </div>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <TextField
            id="reference"
            variant="outlined"
            label="Amount"
            name="amount"
            className={`w-100`}
            onChange={(e) =>
              setClearData({ ...clearData, amount: e.target.value })
            }
            value={clearData.amount}
          />
        </div>
        <div
          className="btn btn-outline-secondary mr-2"
          style={{ width: "150px" }}
          onClick={props.handleClose}
        >
          Cancel
        </div>
        <div
          className="btn btn-danger"
          style={{ width: "150px" }}
          onClick={onSubmit}
        >
          Submit
        </div>
      </DialogContent>
    </Dialog>
  );
};

const StatusRightMenuArr = [
  { title: "All", value: 0 },
  { title: "Cleared", value: 1 },
  { title: "Open", value: 2 },
  { title: "Disputed", value: 3 },
  { title: "Blocked", value: 4 },
];

const RightMenuStatus = (props) => {
  return (
    <div className="d-flex">
      {StatusRightMenuArr.map((e) => (
        <div
          className={`mr-5 ml-3 ${props.type === e.value && `selected-global-catalogue `
            } f12-500`}
          onClick={() => props.onTypeChange(e.value)}
          style={{ cursor: "pointer" }}
          key={e.title}
        >
          {e.title}
        </div>
      ))}
    </div>
  );
};
